export default __webpack_public_path__ + "static/media/left-arrow.a5044d0d.svg";